import Constants from '../../constants/constants';
import actions from './result_view_actions';

export const resultsActions = {
  resetState: () => {
    return (dispatch) => {
      dispatch({
        type: actions.RESET_RESULTS_STATE,
      });
    };
  },

  shouldGetResults: (flag) => {
    return (dispatch) => {
      dispatch({
        type: actions.SHOULD_GET_RESULTS,
        flag: flag,
      });
    };
  },

  startGettingMinutesPlayedData: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_MINUTES_PLAYED,
      });
    };
  },

  startGettingResults: () => {
    return (dispatch) => {
      dispatch({
        type: actions.START_GETTING_RESULTS,
      });
    };
  },
};

const initialState = {
  loaded: false,
  page: 0,
  done: false,
  getting_results: false,
  should_get_results: true,
  results: [],
};

export default function reducer(state = initialState, action = {}) {
  let done = false;

  if (action.results?.length < Constants.RESULTS_PAGE_SIZE) {
    done = true;
  }

  switch (action.type) {
    case actions.RESET_RESULTS_STATE:
      return {
        ...state,
        loaded: false,
        page: 0,
        done: false,
        getting_results: false,
        should_get_results: true,
        results: [],
      };
    case actions.SHOULD_GET_RESULTS:
      return {
        ...state,
        should_get_results: action.flag,
      };
    case actions.START_GETTING_RESULTS:
      return {
        ...state,
        should_get_results: false,
        getting_results: true,
      };
    case actions.ADD_RESULTS_TO_LIST:
      return {
        ...state,
        results: state.results.concat(action.results),
        page: state.page + 1,
        done: done,
        loaded: true,
        should_get_results: false,
        getting_results: false,
      };
    default:
      return state;
  }
}
